export enum RouteAnimationsEnum {
	viewByType = 'viewByType',
	viewByAuthor = 'viewByAuthor',
	viewByList = 'viewByList',
	viewByDate = 'viewByDate',
	entryPreview = 'entryPreview',
	editEntry = 'editEntry',
	templates = 'templates',
	overview = 'overview',
	templatesCreate = 'templatesCreate',
	templatesEdit = 'templatesEdit',
	templatesDuplicate = 'templatesDuplicate'
}
